// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Me","articleImagesWrap":"Ne","articleImage":"Oe","singleImage":"Pe"};